var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    _vm._g(
      { class: _vm.componentClass, style: _vm.componentStyle },
      _vm.isInteractive ? _vm.$listeners : {}
    ),
    [
      _vm.explanation
        ? _c("span", { staticClass: "sr-only" }, [
            _vm._v("\n    " + _vm._s(_vm.explanation) + "\n  "),
          ])
        : _vm._e(),
      _vm._v("\n  " + _vm._s(_vm.label) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }